module.exports = __webpack_public_path__ + "img/igigi-logo.582ff02d.png";